export const BACKEND_ENDPOINTS = {
    ECOM_PRODUCTS: "/events/shop/products?page=1",
    PRODUCT: "/events/product/",
    CALCULATED_DATE_RETURN: `${process?.env?.BACKEND_URL}box/calculated-date-return`,
    CREATE_BOX: `${process?.env?.BACKEND_URL}box/create-box`,
    VALIDATE_PAYMENT_SESSION: `${process?.env?.BACKEND_URL}ecommerce/apple-payment-authorize/`,
    APPLE_PAYMENT: `${process?.env?.BACKEND_URL}ecommerce/apple-collect-payment/`,
    SURVEY_APPLE_PAY_VALIDATE: `${process?.env?.BACKEND_URL}payment/validateSession/`,
    SURVEY_APPLE_PAYMENT: `${process?.env?.BACKEND_URL}payment/ApplePayPayment/`,
};
export const FRONTEND_ENDPOINTS = {
    HOME: "/",
    STYLING: "/styling",
    LOGIN: "/login",
    BOX_SIGNUP: "/survey-register",
    SHOP_SIGNUP: "/shop/ecom-register",
    SIGNUP: "/register",
    MARAM: "/shop/wear-that-x-maram/",
    SUMMER_SHOP: "/the-summer-shop",
    MODEST_SHOP: "/the-modest-shop",
    SERENA_LEFT_CHAT: "/shop/serena-has-left-the-chat",
    SALE: "/sale",
    SHOP: "/shop",
    SOHA: "/shop/soha",
    CART: "/shop/cart",
    TAMARA: "/shop/tamara",
    PRODUCTS: "/shop/products",
    LATEST_PRODUCTS: "/shop/products?order=DESC&sort_by=created_at",
    SHOP_CHECKOUT: "/shop/checkout",
    WEARTHAT_X_MUZI: "/shop/muzi",
    NEW_JESSIE_LINK: "/shop/jessie",
    PARTY_EDIT: "/shop/the-party-edit",
    BASMA: "/shop/basma",
    SERENA_SPARKLES: "/shop/serena-sparkles",
    WEARTHAT_X_KIKA: "/shop/wear-that-x-kika",
    FALL_EDIT: "/shop/products?categories=179",
    SERENA_EDIT: "/shop/products?categories=176",
    HOT_LIST_LINK: "/shop/products?categories=123",
    PRE_STYLED_BOXES: "/shop/products?categories=103",
    FRENCH_GIRL_EDIT: "/shop/products?categories=178",
    OLD_MONEY_EDIT_LINK: "/shop/products?categories=148",
    BASMA_PRODUCTS_LINK: "/shop/products?categories=100",
    TAMARA_PRODUCTS_LINK: "/shop/products?categories=106",
    SERENA_PRODUCTS_LINK: "/shop/products?categories=108",
    JESSIE_PRODUCTS_LINK: "/shop/products?categories=124",
    FALLING_FOR_SERENA_EDIT: "/shop/products?categories=177",
    MONO_EDIT_PRODUCTS_LINK: "/shop/products?categories=117",
    MODEST_EDIT_PRODUCTS_LINK: "/shop/products?categories=120",
    TRENDING_PRODUCTS_LINK: "/shop/products?sort=trending-desc",
    CAPSULE_EDIT_PRODUCTS_LINK: "/shop/products?categories=118",
    THE_SUMMER_EDIT_PRODUCTS_LINK: "/shop/products?categories=136",
    SERENA_BY_THE_SEA_PRODUCTS_LINK: "/shop/products?categories=135",
    SERENA_OWNS_THE_WORK: "/shop/SERENA-OWNS-THE-ROOM",
    SERENA_RAMADAN: "/shop/serena-ramadan",
    SERENA_SPRING: "/shop/serena-spring",
    SPRING_ALL_EDIT: "/shop/serena-spring",
    SPRING_WORK_EDIT: "/shop/serena-spring/serena-spring-work",
    SPRING_RESORT_EDIT: "/shop/serena-spring/serena-spring-resort",
    SPRING_AMELIA_EDIT: "/shop/serena-spring/serena-spring-amelia",
    SPRING_MOM_EDIT: "/shop/serena-spring/serena-spring-mom",
    SPRING_ZEINA_EDIT: "/shop/serena-spring/serena-spring-zeina",
    SPRING_TAMARA_EDIT: "/shop/serena-spring/serena-spring-tamara",
    CORPORATE_EDIT_LINK: "/shop/edits/corporate-edit",
    ALL_EDITS_LINK: "/shop/edits/all-work-edit",
    CREATIVE_EDIT_LINK: "/shop/edits/creative-edit",
    EDUCATION_EDIT_LINK: "/shop/edits/education-edit",
    MANAGEMENT_EDIT_LINK: "/shop/edits/event-pr-management-edit",
    ENTREPERNEURIAL_EDIT_LINK: "/shop/edits/entrepreneurial-edit",
    SURVEY: "/survey",
    WELCOME_USER: "/welcome",
    SURVEY_COMPLETE: "/survey-complete",
    DASHBOARD: "/dashboard",
    FAQ: "/faqs",
    JOURNALS: "/blogs",
    DASHBOARD_FAQ: "/dashboard/faqs",
    ORDER_A_BOX: "/dashboard/orderABox",
    MY_ORDERS: "/dashboard/my-orders",
    MY_BOXES_LINK: "/dashboard/myBoxes",
    MY_ACCOUNT_LINK: "/dashboard/my-account",
    MY_STYLE_PROFIL: "/dashboard/myStyleProfile",
    MY_STYLE_JOURNEY: "/dashboard/myStyleJourney",
    ACCOUNT_SETTINGS: "/dashboard/accountSettings",
    PROFILE_SETUP: "/dashboard/accountSettings/profileSetup",
    CHANGE_PASSWORD: "/dashboard/accountSettings/changePassword",
    ADDRESS_DETAILS: "/dashboard/accountSettings/addressDetails",
    PAYMENT_DETAILS: "/dashboard/accountSettings/paymentDetails",
    STYLE_MY_WARDROBE: "/style-my-wardrobe",
    STYLE_MY_WARDROBE_FORM: "/style-my-wardrobe/wardrobe-styling-form",
    CHECKOUT_ADDRESS: "/checkout?step=address",
    QUICK_SURVEY_REGISTER: "/quick-survey-register",
    PASSWORD_RESET_SUCCESS: "/login?toast=true",
    OLD_MONEY_EDIT_EXTERNAL_LINK: "https://my.wearthat.me/old-money",
    PRIVACY_POLICY: "/documents/privacy-policy/",
    TERMS_CONDITIONS: "/documents/terms-and-conditions/",
    WISH_LIST: "/dashboard/wishlist",
    CONTACT_US: "/contact-us",
    STYLISTS: "/stylists",
    APPLE_PAY_PAYMENT_SUCCESS:
        "/shop/checkout/payment-success?applePaySuccess=true",
    SURVEY_APPLE_PAY_SUCCESS: "/apple-pay-payment-success",
    SURVEY_APPLE_PAY_SUCCESS_INTL: "/sa-apple-pay-payment-success",
};
